import React, { useEffect, useState, useCallback, useRef } from 'react';
import moment from 'moment';
import { Table, DatePicker, ComboBox } from 'components';
import { FormDetail } from './form-detail';
import { Box, IconButton, Typography, Stack } from '@mui/material';
import Utils from 'commons/utils';
import ApiServices from 'services';
import { BsArrowDownCircle } from 'react-icons/bs';

import SearchIcon from '@mui/icons-material/Search';

import { Columns } from './columns';
import { ContainerHeader, ButtonExport } from './styles';
import { RESPONSE_STATUSES } from 'commons/constants';
import { debounce } from 'lodash';

const START_DATE = moment().startOf('month').format();
const END_DATE = moment().endOf('date').format();

const ALL_OPTION = {
  id: 'all',
  code: 'all',
  name: 'Tất cả',
};

const DEFAULT_FILTER = {
  fromDate: START_DATE,
  toDate: END_DATE,
  logUser: ALL_OPTION?.id,
};

function TaskJobReport() {
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState(DEFAULT_FILTER);

  // search Date
  const [startDate, setStartDate] = useState(START_DATE);
  const [endDate, setEndDate] = useState(END_DATE);

  const [userList, setUserList] = useState([]);
  const [userSelected, setUserSelected] = useState(ALL_OPTION);

  const initData = (query) => {
    const userId = query?.logUser ? query?.logUser : filter?.logUser;

    const newQuery = {
      fromDate: query?.fromDate
        ? Utils.convertToDateFormat_New(query?.fromDate)
        : Utils.convertToDateFormat_New(filter?.fromDate),
      toDate: query?.toDate
        ? Utils.convertToDateFormat_New(query?.toDate)
        : Utils.convertToDateFormat_New(filter?.toDate),
      logUser: userId === 'all' ? null : userId,
    };

    console.log({ newQuery });

    setLoading(true);
    return ApiServices.getEmployeeTaskReport(newQuery)
      .then((res) => {
        if (res?.data) {
          setDataList(res?.data || []);
        }
      })
      .catch((err) => console.warn('getEmployeeTaskReport:', err))
      .finally(() => setLoading(false));
  };

  const handleSearchColumn = (event) => {
    setFilter((prev) => {
      const searchArray = { ...prev.searchArray };
      const { value, name } = event.target;
      if (!value) {
        delete searchArray[name];
        return { ...prev, pageNumber: 1, searchArray };
      }
      searchArray[name] = value;
      return { ...prev, pageNumber: 1, searchArray };
    });
  };
  const timeoutGetData = useCallback(
    debounce((newFilter) => {
      initData(newFilter);
    }, 500),
    [],
  );
  useEffect(() => {
    timeoutGetData(filter);
  }, [filter]);

  const getUserbyPermission = async () => {
    setLoading(true);
    try {
      const res = await ApiServices.getUserbyPermission();
      if (res?.data) {
        setUserList([ALL_OPTION, ...res?.data] || []);
      } else {
        setUserList([]);
      }
      console.log('getUserbyPermission::', res?.data);
    } catch (error) {
      console.warn('getUserbyPermission:', error);
      setUserList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserbyPermission();
  }, []);

  const reloadData = async () => {
    return await initData(filter);
  };

  const handleChangeStartDate = useCallback(
    (event) => {
      setStartDate(event.target.value);
    },
    [startDate],
  );
  const handleChangeEndDate = useCallback(
    (event) => {
      setEndDate(event.target.value);
    },
    [endDate],
  );

  const handleChangeUserSelected = useCallback(
    (_, newValue) => {
      const val = newValue ? newValue : ALL_OPTION;
      setUserSelected(val);
      setFilter((prev) => ({ ...prev, logUser: val?.code }));
    },
    [userSelected],
  );

  const handleSearchDate = (startDateSearch, endDateSearch) => {
    if (!startDateSearch || !endDateSearch) return;
    setFilter((prev) => ({ ...prev, fromDate: startDateSearch, toDate: endDateSearch }));
  };

  const deleteItem = async (row) => {
    if (!row?.id) return;

    setLoading(true);
    return ApiServices.deleteClientComplaint(row?.id)
      .then((res) => {
        if (res.status === RESPONSE_STATUSES.OK) {
          window.UIMessage?.success('Xóa thành công');
          reloadData();
        }
      })
      .catch((err) => {
        window.UIMessage?.error('Xóa thất bại !!!');
        console.warn('deleteClientComplaint', err);
      })
      .finally(() => setLoading(false));
  };

  const handleExportClient = (query) => {
    const startDate = moment(query?.fromDate).format('YYYY-MM-DD');
    const endDate = moment(query?.toDate).format('YYYY-MM-DD');

    const startDateFormat = moment(query?.fromDate).format('DD-MM-YYYY');
    const endDateFormat = moment(query?.toDate).format('DD-MM-YYYY');

    setLoading(true);
    return ApiServices.exportExcelEmployeeTaskReport(startDate, endDate)
      .then((res) => {
        if (res?.data) {
          Utils.exportTemplate(
            res?.data,
            `Báo_Cáo_Công_Việc_From_${startDateFormat}_To_${endDateFormat}.xlsx`,
          );
        }
      })
      .catch((err) => {
        console.log('Export Client file error:', err);
        window.UIMessage?.error('Tải thất bại !!!');
      })
      .finally(() => setLoading(false));
  };

  const renderHeader = () => (
    <>
      <ContainerHeader>
        <Stack spacing={2} direction="row">
          <Box sx={{ width: '160px' }}>
            <DatePicker
              sx={{
                marginBottom: '10px',
                padding: 0,
              }}
              width={100}
              marginTop="0"
              size="small"
              onChange={handleChangeStartDate}
              value={startDate}
              error={true}
              label="Từ ngày"
            />
          </Box>
          <Box sx={{ width: '160px' }}>
            <DatePicker
              sx={{
                marginBottom: '10px',
                padding: 0,
              }}
              width={100}
              marginTop="0"
              size="small"
              onChange={handleChangeEndDate}
              value={endDate}
              error={true}
              label="Đến ngày"
            />
          </Box>
          <Box sx={{ width: '260px' }}>
            <ComboBox
              disableClearable={true}
              options={userList}
              label="Nhân viên"
              sx={{ width: '100%' }}
              keyField="name"
              value={userSelected}
              onChange={handleChangeUserSelected}
            />
          </Box>

          <IconButton
            aria-label="filter"
            sx={{ color: 'blue' }}
            onClick={() => handleSearchDate(startDate, endDate)}
          >
            <SearchIcon />
          </IconButton>
        </Stack>
      </ContainerHeader>

      <ButtonExport
        variant="contained"
        startIcon={<BsArrowDownCircle />}
        onClick={() => handleExportClient(filter)}
      >
        Tải excel
      </ButtonExport>
    </>
  );

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Typography variant="h6" component="h6" sx={{ marginBottom: '10px' }}>
          BÁO CÁO CÔNG VIỆC
        </Typography>
        <Table
          key="stt"
          filter={filter}
          rows={dataList}
          headCells={Columns(handleSearchColumn, deleteItem)}
          loading={loading}
          renderHeader={renderHeader}
        />
        <FormDetail {...{ selected, setSelected, reloadData }} />
      </Box>
    </>
  );
}
export { TaskJobReport };
